import { render, staticRenderFns } from "./TinymceVue.vue?vue&type=template&id=231a94b2&scoped=true&"
import script from "./TinymceVue.vue?vue&type=script&lang=js&"
export * from "./TinymceVue.vue?vue&type=script&lang=js&"
import style0 from "./TinymceVue.vue?vue&type=style&index=0&id=231a94b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231a94b2",
  null
  
)

component.options.__file = "TinymceVue.vue"
export default component.exports